import React from 'react';
import { useTranslation } from 'react-i18next';
import { DataTable, DateTimeField, Field } from '../../commons/DataTable';
import LinkField from '../../commons/DataTable/LinkField';
import QrField from '../../commons/DataTable/QrField';
import DownloadQrField from '../../commons/DataTable/DownloadQrField';

function QrCodesTable({ data, total, offset, limit, onFilter, profile }) {
  const [t] = useTranslation('MARKETING');

  return (
    <DataTable
      data={data}
      total={total}
      offset={offset}
      limit={limit}
      onFilter={onFilter}
      emptyText={t('COMMON:NO_DATA')}
    >
      <QrField title="Qr" source="src.png" className="text-center" />
      <LinkField
        title="Link pubblico"
        source="src.landing"
        className="text-left"
      />
      <Field title="Nome" source="name" className="text-left" />
      <LinkField
        title="Destinazione"
        source="destination"
        className="text-left"
      />
      <Field title="Hit" source="total_hits" className="text-left" />
      <DateTimeField
        title="Creato il"
        source="date_added"
        className="text-left"
        format="DD/MM/YYYY"
      />
      <DownloadQrField title="Azioni" className="text-center" />
    </DataTable>
  );
}

export default QrCodesTable;
